<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Validar Carregamento Romaneio"
  [p-actions]=actions
>

<div class="po-row">
  <po-widget
    class="po-md-12"
    (p-setting)="clickInformacoes()"
    p-title="Informações do Romaneio"
  >
    @if(apareceInformacoes){
      <div>
        <po-info class="po-md-3" p-label="Código" [p-value]="romaneio.CZ00COD"></po-info>
        <po-info class="po-md-3" p-label="Placa" [p-value]="romaneio.CZ00PLACA"></po-info>
        <po-info class="po-md-3" p-label="Usuário" [p-value]="romaneio.CZ00USER"></po-info>
        <po-info class="po-md-3" p-label="Nome Usuário" [p-value]="romaneio.CUSRNOME"></po-info>
        <po-info class="po-md-3" p-label="Local Origem" [p-value]="romaneio.CZ00ORIGEM"></po-info>
        <po-info class="po-md-3" p-label="Local Destino" [p-value]="romaneio.CZ00DESTIN"></po-info>
      </div>
    }
  </po-widget>
</div>

<po-input
[p-auto-focus]="true"
class="po-md-10"
name="etiqueta"
[(ngModel)]="etiqueta"
p-label="Etiqueta"
(keyup.enter)="biparEtiqueta()"
></po-input>

<h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Etiquetas Romaneio {{tituloTable}}</h1>
<div class="po-row">
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-striped]="true"
    [p-items]="romaneio.items"
    [p-columns]="colunas"
    p-spacing="small"
  ></po-table>
</div>

</po-page-default>



